import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex justify-between" }
const _hoisted_2 = ["for"]
const _hoisted_3 = { class: "flex relative rounded-none shadow-sm h-full" }
const _hoisted_4 = { class: "flex relative w-full" }
const _hoisted_5 = { class: "flex absolute inset-y-0 left-0" }
const _hoisted_6 = {
  key: 0,
  class: "pl-3 flex items-center pointer-events-none"
}
const _hoisted_7 = {
  class: "h-5 w-5 text-gray-400",
  "aria-hidden": "true"
}
const _hoisted_8 = ["type", "name", "id", "placeholder", "value"]
const _hoisted_9 = {
  key: 0,
  class: "pr-3 flex items-center"
}
const _hoisted_10 = { class: "h-5 w-5 text-gray-400" }

import {
		nextTick
	} from "vue"

	
	const __default__ = { name: 'SearchInput' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		modelValue: {
			type: [String, Number],
			default: null
		},
		id: {
			type: String,
			default: ''
		},
		label: {
			type: String,
			default: ''
		}, 
		placeholder: {
			type: String,
			default: ''
		},
		type: {
			type: String,
			default: 'text'
		},
		dropdown: {
			type: Boolean,
			default: false
		}
	},
  emits: [
		'update:modelValue'
	],
  setup(__props, { emit: __emit }) {

	const props = __props

	const emit = __emit

	// update modeled value
	const onInput = async ({ target }: any) => {
		emit('update:modelValue', target.value)
		await nextTick()
		return
	}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("label", {
        for: __props.id,
        class: "block text-sm font-medium text-gray-700 sr-only"
      }, _toDisplayString(__props.label), 9, _hoisted_2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (_ctx.$slots.icon)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, [
                  _renderSlot(_ctx.$slots, "icon")
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("input", {
          type: __props.type ?? 'text',
          name: __props.label,
          id: __props.id,
          class: "pl-10 flex-1 min-w-0 block focus:ring-brand-500 focus:border-brand-500 w-full sm:text-sm border-transparent rounded-none py-4",
          placeholder: __props.placeholder,
          onInput: onInput,
          value: __props.modelValue
        }, null, 40, _hoisted_8),
        _createElementVNode("div", {
          class: _normalizeClass([__props.dropdown ? 'right-12' : 'right-0', 'flex absolute inset-y-0 cursor-pointer'])
        }, [
          (_ctx.$slots.trailing_inline)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("span", _hoisted_10, [
                  _renderSlot(_ctx.$slots, "trailing_inline")
                ])
              ]))
            : _createCommentVNode("", true)
        ], 2)
      ])
    ])
  ]))
}
}

})